export class CryptoService {
    /**
     * Bernstein's 'times 33' hash algorithm.
     * The result is case-sensitive.
     */
    unsafeShortHash(text) {
        let hash = 5381;
        let index = text.length;
        while (index) {
            hash = (hash * 33) ^ text.charCodeAt(--index);
        }
        hash = hash >>> 0;
        return hash.toString(36);
    }
}
//# sourceMappingURL=crypto.service.js.map